import { Injectable, signal } from '@angular/core';
import { SponserModel } from '../Model/sponser.model';

@Injectable({
    providedIn: 'root'
})
export class SharedSponserService {

    bronzeSponsors = signal<SponserModel[]>([]);
    otherSponsors = signal<SponserModel[]>([]);

    setSponsors(data: SponserModel[]) {
        this.bronzeSponsors.set(
            data.filter(s => s.sponsorType === 'Bronze')
        );

        this.otherSponsors.set(
            data.filter(s => s.sponsorType !== 'Bronze')
        );
    }

    getBronzeSponsors() {
        return this.bronzeSponsors;
    }

    getOtherSponsors() {
        return this.otherSponsors;
    }
}
